/**
 * Color validation utilities for question options
 */

/**
 * Regular expression for validating hex color format
 * Matches 3-digit or 6-digit hex colors with # prefix
 * Valid: #1976d2, #fff, #FF0000
 * Invalid: rgb(...), blue, #12345
 */
export const HEX_COLOR_REGEX = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;

/**
 * Default swatch color (gray) when no custom color is set
 */
export const DEFAULT_SWATCH_COLOR = '#e0e0e0';

/**
 * Validates whether a color string is a valid hex color format
 * @param color - Color string to validate (e.g., "#1976d2")
 * @returns true if color is undefined (optional field) or valid hex format
 */
export const isValidHexColor = (color: string | undefined): boolean => {
  if (!color) return true; // undefined is valid (optional field)
  return HEX_COLOR_REGEX.test(color);
};
